import { EventEmitter, Injectable } from '@angular/core';
import { ITelephonyEvent } from '../interfaces/telephony/telephony-event';
import { IProfileJobInfo } from '../interfaces/telephony/profile-job-info';
import { ISupplierInfoEvent } from '../interfaces/telephony/supplier-info-event';
import { IOrganisationSelectorEvent } from '../interfaces/telephony/organisation-selector-event';
import { IInteractionEvent } from '../interfaces/interactions/interaction-event';
import { ITelephonyUser } from '../interfaces/telephony/telephony-user.interface';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  public JobSearchEvent: EventEmitter<any> = new EventEmitter<any>();

  // differentiate this from the event coming from the websockets broadcast service
  public InternalTelephonyEvent: EventEmitter<ITelephonyEvent> =
    new EventEmitter<ITelephonyEvent>();

  public JobViewEvent: EventEmitter<any> = new EventEmitter<any>();
  public RefreshJobEvent: EventEmitter<any> = new EventEmitter<any>();

  public InteractionEvent: EventEmitter<IInteractionEvent> = new EventEmitter();

  public SupplierInfoEvent: EventEmitter<ISupplierInfoEvent> =
    new EventEmitter<ISupplierInfoEvent>();

  public DisassociateJobFromCall: EventEmitter<number> = new EventEmitter<number>();

  public OrganisationSelectorEvent: EventEmitter<IOrganisationSelectorEvent> =
    new EventEmitter<IOrganisationSelectorEvent>();

  // arguments are dateRangeType (i.e. days, weeks etc.) and range value (i.e. 7 - for 7 days etc.)
  public CustomerKPIRefreshEvent: EventEmitter<{
    tabIndex: number;
    dateRangeType: number;
    dateRangeValue: number;
    dept: number;
    orderTag: number;
  }> = new EventEmitter();

  public DelayFailureRefreshEvent: EventEmitter<any> = new EventEmitter<any>();
  public TransactionSearchEvent: EventEmitter<any> = new EventEmitter<any>();
  public ReportChangedEvent: EventEmitter<any> = new EventEmitter<any>();
  public RefreshIncidentsEvent: EventEmitter<any> = new EventEmitter<any>();
  public JobRejectionEvent: EventEmitter<{ action: string; jobId: number; reject?: boolean }> =
    new EventEmitter<{
      action: string;
      jobId: number;
    }>();
  public JobWatchedEvent: EventEmitter<{ id: number; watched: boolean }> = new EventEmitter<{
    id: number;
    watched: boolean;
  }>();

  public JobScreenEvent: EventEmitter<IJobScreenEvent> = new EventEmitter<IJobScreenEvent>();
}

declare type JobScreenEventType =
  | 'job-details-changed'
  | 'refresh-order'
  | 'refresh-notes'
  | 'task-changed'
  | 'refresh-task-times'
  | 'refresh-supplier'
  | 'log-call'
  | 'refresh-incidents'
  | 'order-changed'
  | 'sequence-update'
  | 'job-rejected'
  | 'refresh-job'
  | 'task-type-changed'
  | 'vehicle-updated'
  | 'refresh-task-details'
  | 'refresh-schedule';

export interface IJobScreenEvent {
  event: JobScreenEventType;
  sender?: string;
  data?: any;
}
